import { FC } from "react";
import { Box, Typography } from "@mui/material";
import ArrowRightIcon from "../../assets/icons/red-arrow-right.svg";
import { Colors } from "../../styles/constant";
import { defaultEmptyFun } from "../../utils/helper";

interface Props {
  title: string;
  titleSize?: number | string;
  onClick?: any;
  imgWidth?: string;
  className?: string;
}

const CustomLink: FC<Props> = ({
  title = "",
  titleSize = ".875rem",
  onClick = defaultEmptyFun,
  imgWidth = "auto",
  className,
}) => {
  return (
    <Box
      display="flex"
      alignItems="baseline"
      sx={{ cursor: "pointer" }}
      onClick={onClick}
      className={className}
    >
      <Typography
        marginRight=".5rem"
        color={Colors.red}
        fontSize={titleSize}
        variant="h5"
        sx={{ wordBreak: "break-word" }}
      >
        {title}
      </Typography>
      <img
        src={ArrowRightIcon}
        alt="right-arrow"
        style={{ color: Colors.red, width: imgWidth }}
      />
    </Box>
  );
};

export default CustomLink;
